<template>
  <el-collapse v-model="activeNames" style="border-radius: 10px;">
    <el-collapse-item name="1">
      <template slot="title">
        <div style="font-size: 16px; font-weight: 600;width:100%">{{ title }}</div>
      </template>
      <div style="padding: 20px;padding-bottom: 0px; font-size:16px;">
        <img v-if="displaySignature" :src="displaySignature" alt="簽名圖片" class="signature-preview" />
        <div v-else class="signature-preview no-signature">無簽名資料</div>
      </div>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
export default {
  name: 'SignatureViewPartial',
  props: {
    signaturePath: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: '簽名區',
    },
  },
  data() {
    return {
      signatureData: null,
      activeNames: ['1'], // 控制預設是否展開 ['1'] 展開， [] 收合'
    }
  },
  methods: {},
  computed: {
    displaySignature() {
      return this.signaturePath || this.signatureData
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-dialog--center .el-dialog__body {
  padding: 0px;
}
::v-deep .el-collapse-item__header {
  background-color: #e5e7eb;
  border-radius: 10px;
}

::v-deep .el-collapse-item__header.is-active {
  border-radius: 10px 10px 0 0;
}

::v-deep .el-collapse-item__arrow {
  font-size: 26px;
  font-weight: 900;
}

::v-deep .el-divider--vertical {
  height: 2.2em;
  background-color: #e5e7eb;
  margin-top: 10px;
}

.signature-preview {
  width: 100%;
  height: 180px;
  object-fit: contain;
  border: solid 2px #e5e7eb;
  border-radius: 8px;
}

.no-signature {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 180px;
  font-size: 18px;
  color: #999;
}
</style>
